import * as React from 'react';
export const gavelSvg = React.forwardRef(function gavelSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M.87 7.17 7.677.37a1.25 1.25 0 0 1 1.772 0l2.896 2.893a1.262 1.262 0 0 1-.013 1.757l-2.008 2.006 4.467 4.232a2.14 2.14 0 0 1 .088 3.098l-.005.004a2.128 2.128 0 0 1-3.107-.085l-4.234-4.46-2.008 2.005a1.247 1.247 0 0 1-1.772 0L.87 8.94a1.247 1.247 0 0 1 0-1.77Zm7.693-5.564L7.467 2.7l1.091 1.09a.75.75 0 1 1-1.062 1.06l-1.09-1.09L4.264 5.9l1.091 1.09a.75.75 0 1 1-1.061 1.06L3.203 6.96 2.107 8.056l2.532 2.53 6.456-6.45-2.532-2.53Zm.032 7.148 4.282 4.512.011.012a.625.625 0 0 0 .922.024.64.64 0 0 0-.024-.93l-.01-.009-4.514-4.276-.667.667ZM.5 15.25a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z',
    }),
  );
});
gavelSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var gavel = {
  category: 'icon',
  colorable: true,
  name: 'gavel',
  svg: gavelSvg,
};
